import { action, observable } from 'mobx'

import Ds from './ds'

class Features {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllFeatures() {
    this.ds.query(`{ features(hash: "${ localStorage.getItem('userHash') }") { id name description baseCost } }`, (data) => {
      this.data = data.features
    })
  }

  @action newFeature(row) {
    this.ds.query(`mutation { addFeature(name: "${ row.name }", description: "${ row.description }", baseCost: ${ row.baseCost }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllFeatures()
    })
  }

  @action updateFeature(row) {
    this.ds.query(`mutation { updateFeature(id: ${ row.id }, name: "${ row.name }", baseCost: ${ row.baseCost }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllFeatures()
    })
  }

  @action deleteFeature(id) {
    this.ds.query(`mutation { deleteFeature(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllFeatures()
    })
  }
}

export default new Features()



// WEBPACK FOOTER //
// ./src/stores/features.js